import { Stack, Divider, Typography } from "@mui/material";
import FacebookIcon from "../assets/images/socialMediaIcons/fb.png";
import GoogleIcon from "../assets/images/socialMediaIcons/google.png";
import TwitterIcon from "../assets/images/socialMediaIcons/twitter.png";
import Button from "../components/common/button/Button";
import Spotify from "../features/spotify/Spotify";
import DividerDotted from "../assets/images/icons/DividerDotted.png";
import spotifyLogo from "../assets/images/spotify/spotifyLogo2.png";

export default function AuthSocial({ vanityLinkData, SsoProvider, origin }) {
    const getRedirectPath = () => {
        if (typeof vanityLinkData?.clientName === "string" && vanityLinkData.clientName.trim() !== "") {
            return vanityLinkData.clientName.startsWith("/")
                ? vanityLinkData.clientName
                : `/${vanityLinkData.clientName}`;
        }

        return window.location.pathname;
    };

    const handleSocialLogin = (provider) => {
        const redirectPath = getRedirectPath();
        const baseUrl = process.env.REACT_APP_CORE_API_URI;

        if (!baseUrl) {
            console.error("REACT_APP_CORE_API_URI is not defined in environment variables.");
            return;
        }

        let loginUrl = "";

        switch (provider) {
            case "google":
                loginUrl = `${baseUrl}/web/users/auth/google?redirectUrl=${encodeURIComponent(redirectPath)}`;
                break;
            case "spotify":
                loginUrl = `${baseUrl}/web/spotify/auth/spotify?redirectUrl=${encodeURIComponent(redirectPath)}`;
                break;
            default:
                console.error(`Unsupported provider: ${provider}`);
                return;
        }

        window.open(loginUrl, "_self");
    };

    return (
        <>
            <>
                {(origin === "loginPage" || SsoProvider === "google") && (
                    <>
                        {SsoProvider === "google" && (
                            <img style={{ width: "100%", margin: "1rem 0" }} src={DividerDotted} alt="Divider Dotted" />
                        )}
                        <Button
                            customIcon={GoogleIcon}
                            backgroundColor={"black"}
                            labelColor={"white"}
                            border={"grey"}
                            buttonWidth={"560px"}
                            borderRadius={"0px"}
                            margin={"0px 0px 25px 0px"}
                            label="Continue with Google"
                            variant="VanityLinkCustomizable"
                            customIconMargin={"0px 20px 0px 0px"}
                            onClick={() => handleSocialLogin("google")}
                        />
                    </>
                )}

                {(origin === "loginPage" || SsoProvider === "spotify") && (
                    <Button
                        customIcon={spotifyLogo}
                        backgroundColor={"black"}
                        labelColor={"white"}
                        border={"grey"}
                        buttonWidth={"560px"}
                        borderRadius={"0px"}
                        customIconMargin={"0px 20px 0px 0px"}
                        margin={"0px 0px 30px 0px"}
                        iconSize={"25px"}
                        label="Continue with Spotify"
                        variant="VanityLinkCustomizable"
                        onClick={() => handleSocialLogin("spotify")}
                    />
                )}
            </>

            {/* </Stack> */}
            {/* <Button
          onClick={() => handleSocialLogin('facebook')}
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          style={{ backgroundColor: '#3479EA' }}
        >
          <img src={FacebookIcon} alt="Facebook Sign-In" width={22} height={22} />
        </Button>

        <Button
          onClick={() => handleSocialLogin('twitter')}
          fullWidth
          size="large"
          color="inherit"
          variant="outlined"
          style={{ backgroundColor: '#55D4FD' }}
        >
          <img src={TwitterIcon} alt="Twitter Sign-In" width={22} height={22} />
        </Button> */}

            {/* <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          OR
        </Typography>
      </Divider> */}
        </>
    );
}
